import React from "react";
import {connect} from "react-redux";
import {userActions} from "../../_actions";
import AsyncSelect from "react-select/async";
import {components as reactSelect} from "react-select";
import {buscadorService} from "../../_services";
import {busquedaActions} from "../../_actions/busqueda.actions";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import cartService from "../../_services/cart/cart.service";
import {history} from "../../_helpers";
import authService from "../../_services/cart/authService";
import chatService from "../../_services/cart/chat.service";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import Nav from "react-bootstrap/Nav";
import Navbar from "react-bootstrap/Navbar";
import NavDropdown from "react-bootstrap/NavDropdown";
import Offcanvas from "react-bootstrap/Offcanvas";
import {NotificacionesBell} from "./NotificacionesBell";

/** Tiene que coincidir con SearchTexto.MIN_CARACTERES del back. */
const MIN_CARACTERES_BUSQUEDA = 2;

const DEBOUNCE_BUSQUEDA_MS = 250;

/**
 * Item de texto libre, siempre al final de las sugerencias.
 *
 * <p>Las sugerencias solo pueden ofrecer lo que es una fila de una tabla, y hay busquedas que
 * no le corresponden a ninguna: "paragolpes ford focus" cruza tres. Esta opcion manda la
 * consulta tal cual al listado, que la resuelve por texto libre.
 */
const opcionTexto = (termino) => ({
    id: "texto:" + termino,
    tipo: "TEXTO",
    nombre: termino,
});

/**
 * La lupa del buscador, en el lugar donde react-select pone su flecha.
 *
 * <p>Esto es un buscador con autocompletado, no un desplegable: la flecha de select prometia
 * una lista de opciones para abrir, que no existe hasta que la persona escribe.
 *
 * <p>Con texto escrito la lupa busca: elige la opcion de texto libre, igual que si la persona la
 * hubiera seleccionado de la lista. El comportamiento de fabrica era abrir/cerrar el menu, y al
 * perder el foco react-select borraba lo tipeado: se clickeaba la lupa y no pasaba nada.
 */
const IndicadorLupa = (props) => {
    const buscar = (handlerOriginal) => (event) => {
        const termino = (props.selectProps.inputValue || "").trim();
        if (termino.length < MIN_CARACTERES_BUSQUEDA) {
            handlerOriginal(event);
            return;
        }
        event.preventDefault();
        event.stopPropagation();
        props.selectOption(opcionTexto(termino));
    };

    return (
        <reactSelect.DropdownIndicator
            {...props}
            innerProps={{
                ...props.innerProps,
                onMouseDown: buscar(props.innerProps.onMouseDown),
                onTouchEnd: buscar(props.innerProps.onTouchEnd),
            }}
        >
            <FontAwesomeIcon icon="fa-solid fa-magnifying-glass"/>
        </reactSelect.DropdownIndicator>
    );
};

/**
 * El header del sitio.
 *
 * <h3>El menú se declara una vez y se pinta dos</h3>
 * Bootstrap con `expand="xl"` resuelve el menú de usuario de dos maneras distintas: un panel
 * deslizable en mobile y un dropdown en desktop. Antes cada uno tenía su propia lista escrita a
 * mano, y las dos se fueron separando —"Mis ventas" existía sólo en desktop, así que un vendedor con
 * el celular no tenía cómo llegar a sus ventas—. Ahora la lista vive en {@link secciones} y los dos
 * render la recorren: agregar una entrada es tocar un solo lugar.
 *
 * <h3>Por qué está agrupado y no es una lista corrida</h3>
 * Las acciones del menú no son equivalentes: comprar, vender y administrar son tres roles distintos
 * de la misma persona, y mezclarlos obliga a leer los diez ítems para encontrar el que se busca. Los
 * grupos llevan título y separador, y "Cerrar sesión" queda aparte al final —es la única acción
 * destructiva del menú y no tiene por qué estar pegada a "Mis ventas"—.
 */
class NavBar extends React.Component {

    state = {
        showLogin: false,
        showRegistrar: false,
        mensajesSinLeer: 0,
    };

    componentDidMount() {
        if (authService.isAuthenticated()) {
            // El globo de mensajes se mueve solo: el servicio lo actualiza cuando entra un mensaje
            // por WebSocket, así que el header no necesita preguntar cada tantos segundos.
            this.desuscribir = chatService.onNoLeidos((n) =>
                this.setState({mensajesSinLeer: n.TOTAL || 0})
            );
        }
    }

    componentWillUnmount() {
        if (this.desuscribir) this.desuscribir();
        if (this.debounceBusqueda) clearTimeout(this.debounceBusqueda);
    }

    cerrarSesion = () => {
        this.props.logout();
    };

    ir = (ruta) => {
        history.push(ruta);
        window.scrollTo(0, 0);
    };

    irAIngresar = () => {
        history.push("/login");
    };

    crearNombre = (option) => {
        // El item de texto libre no es una entidad: se muestra como la accion que es.
        if (option.tipo === "TEXTO") {
            return 'Ver todas las publicaciones de "' + option.nombre + '"';
        }

        let nombresFinal = option.nombre;

        if (option.tipo !== "REPUESTO" && option.tipo !== "MARCA") {
            if (option.tipo === "MODELO") {
                nombresFinal = option.marca.nombre + " " + nombresFinal;
            }

            if (option.tipo === "VERSION") {
                nombresFinal = option.marca.nombre + " " + option.modelo.nombre + " " + nombresFinal;
            }
        }

        return nombresFinal;
    };

    filtrarBusqueda = (opt) => {
        this.props.filtrarDesdeBusqueda(opt);
    };

    parsearResult = (list) => (list && list.results ? list.results : []);

    handleClose = () => {
        this.setState({showLogin: false, showRegistrar: false});
    };

    /**
     * Sugerencias del buscador.
     *
     * <p>Antes pedia 4 caracteres para arrancar, asi que "BMW", "Kia", "VW" y "Gol" no disparaban
     * nada. Ahora arranca en 2 y espera a que la persona deje de tipear: sin el debounce cada tecla
     * era un request, y cada request son cuatro consultas contra la base.
     *
     * <p>Nunca rechaza la promesa. La version anterior hacia reject() sin catch cuando el texto era
     * corto, lo que dejaba una promesa rechazada suelta en cada montaje del header.
     */
    promiseOptions = (inputValue) =>
        new Promise((resolve) => {
            const termino = (inputValue || "").trim();

            if (this.debounceBusqueda) clearTimeout(this.debounceBusqueda);

            if (termino.length < MIN_CARACTERES_BUSQUEDA) {
                resolve([]);
                return;
            }

            this.debounceBusqueda = setTimeout(() => {
                buscadorService.buscarNavBar({busqueda: termino}).then(
                    (data) => resolve([...this.parsearResult(data), opcionTexto(termino)]),
                    // Si el back falla, por lo menos que se pueda seguir por texto libre.
                    () => resolve([opcionTexto(termino)])
                );
            }, DEBOUNCE_BUSQUEDA_MS);
        });

    /**
     * El menú, agrupado por lo que la persona está haciendo.
     *
     * <p>Los grupos que no le corresponden no se muestran vacíos: se omiten. Un título "Vendiendo"
     * sin nada abajo le sugiere a un comprador que le falta algo.
     */
    secciones = () => {
        const esVendedor = authService.hasAuthority("VENDEDOR");
        const esAdmin = authService.hasAuthority("ADMIN");
        const {mensajesSinLeer} = this.state;

        const grupos = [];

        grupos.push({
            titulo: "Mi cuenta",
            items: [
                {
                    label: "Mi perfil",
                    icono: "fa-regular fa-circle-user",
                    ruta: esVendedor ? "/vendedor/miPerfil" : "/comprador/miPerfil",
                },
                {
                    label: "Mensajes",
                    icono: "fa-regular fa-comments",
                    ruta: "/mensajes",
                    badge: mensajesSinLeer,
                },
                {label: "Mis alertas", icono: "fa-regular fa-bell", ruta: "/perfil/alertas"},
            ],
        });

        grupos.push({
            titulo: "Comprando",
            items: [
                {label: "Mis compras", icono: "fa-solid fa-bag-shopping", ruta: "/comprador/misCompras"},
                {label: "Mi carrito", icono: "fa-solid fa-cart-shopping", ruta: "/checkout"},
            ],
        });

        if (esVendedor) {
            grupos.push({
                titulo: "Vendiendo",
                items: [
                    {label: "Panel de vendedor", icono: "fa-solid fa-gauge-high", ruta: "/vendedor/dashboard"},
                    {label: "Mis publicaciones", icono: "fa-solid fa-boxes-stacked", ruta: "/vendedor/productos"},
                    {label: "Mis ventas", icono: "fa-solid fa-hand-holding-dollar", ruta: "/vendedor/ventas"},
                    {label: "Qué están buscando", icono: "fa-solid fa-chart-simple", ruta: "/vendedor/demanda"},
                    {label: "Mi Mercado Pago", icono: "fa-solid fa-credit-card", ruta: "/vendedor/miMp"},
                ],
            });
        }

        if (esAdmin) {
            grupos.push({
                titulo: "Administración",
                items: [
                    // Repetida a propósito: un admin que no es vendedor no ve el grupo "Vendiendo",
                    // y sin esta entrada la pantalla de demanda le queda sin acceso desde el header.
                    ...(esVendedor
                        ? []
                        : [{label: "Qué están buscando", icono: "fa-solid fa-chart-simple", ruta: "/vendedor/demanda"}]),
                    {label: "Usuarios", icono: "fa-solid fa-users", ruta: "/admin/usuarios"},
                    {label: "Publicaciones", icono: "fa-solid fa-list-check", ruta: "/admin/publicaciones"},
                    {label: "Ventas", icono: "fa-solid fa-receipt", ruta: "/admin/ventas"},
                    {label: "Consultas", icono: "fa-solid fa-inbox", ruta: "/admin/consultas"},
                    {label: "Marcas y tipos", icono: "fa-solid fa-tags", ruta: "/admin/tipos"},
                ],
            });
        }

        return grupos;
    };

    /** Una entrada del menú, con su ícono y —si tiene— el globo de pendientes. */
    contenidoItem = (item) => (
        <>
            <FontAwesomeIcon icon={item.icono} className="menuUsuario__icono" fixedWidth/>
            <span className="menuUsuario__label">{item.label}</span>
            {item.badge > 0 && (
                <span className="menuUsuario__badge">{item.badge > 9 ? "9+" : item.badge}</span>
            )}
        </>
    );

    render() {
        const {mensajesSinLeer} = this.state;
        const autenticado = authService.isAuthenticated();
        const usuario = autenticado ? authService.getLoggedUser() : null;
        const iniciales = usuario ? usuario.username.substring(0, 2).toUpperCase() : "";

        const customSelect = {
            /*
             * Los colores salen de las variables --buscador-* que define
             * _navigation.scss: en modo oscuro el campo se invierte (claro con texto
             * oscuro) y aca no hay forma de saber en que tema estamos.
             */
            control: (provided, state) => ({
                ...provided,
                display: "flex",
                flexWrap: "nowrap",
                borderWidth: "1px",
                borderColor: state.isFocused ? "var(--accent-500)" : "var(--buscador-borde)",
                // react-select pinta su propio halo azul al enfocar, que no es de la paleta.
                boxShadow: "none",
                ":hover": {
                    borderColor: "var(--accent-500)",
                },
                borderRadius: "3rem",
                width: "80%",
                height: "48px",
                margin: "0 0 0 1rem",
                padding: "0 1rem",
            }),
            // El gris de fabrica de react-select no llega al 4.5:1 que pide WCAG AA
            // contra el fondo del campo, y ademas no sigue al tema.
            placeholder: (provided) => ({
                ...provided,
                color: "var(--buscador-placeholder)",
            }),
            // Lo que se escribe y la opcion elegida se pintan en _navigation.scss, no
            // aca: _forms.scss tiene `input:not(.button)` y `[class*="-singleValue"]`
            // globales con !important, que le ganan a estos estilos inline.
            singleValue: (provided) => ({
                ...provided,
                color: "var(--buscador-texto)",
            }),
            dropdownIndicator: (provided) => ({
                ...provided,
                color: "var(--buscador-placeholder)",
                ":hover": {color: "var(--buscador-texto)"},
            }),
        };

        return (
            <>
                {["xl"].map((expand) => (
                    <Navbar key={expand} expand={expand} className="container__dap">
                        <div className="navbar__dap">
                            <Navbar.Brand
                                onClick={() => history.push("/home")}
                                className="navbar__dap--logo"
                            >
                                <img
                                    src={process.env.PUBLIC_URL + "/images/isologo-original.png"}
                                    width="100"
                                    height="auto"
                                    className="d-inline-block align-top"
                                    alt="Logo"
                                />
                            </Navbar.Brand>

                            <Form className="navbar__dap--search">
                                {/*
                                    Sin `defaultOptions`: no hay nada que mostrar antes de que la
                                    persona escriba, y esa prop disparaba una busqueda con el texto
                                    vacio en cada montaje.
                                */}
                                <AsyncSelect
                                    cacheOptions
                                    placeholder="Buscar repuesto, marca, modelo..."
                                    getOptionLabel={(option) => this.crearNombre(option)}
                                    getOptionValue={(option) => option.id}
                                    loadOptions={(e) => this.promiseOptions(e)}
                                    onChange={(opt) => this.filtrarBusqueda(opt)}
                                    loadingMessage={() => "Buscando..."}
                                    noOptionsMessage={({inputValue}) =>
                                        (inputValue || "").trim().length < MIN_CARACTERES_BUSQUEDA
                                            ? "Escribí al menos " + MIN_CARACTERES_BUSQUEDA + " letras"
                                            : "Sin resultados"
                                    }
                                    styles={customSelect}
                                    components={{
                                        DropdownIndicator: IndicadorLupa,
                                        IndicatorSeparator: null,
                                    }}
                                />
                            </Form>

                            <div className="navbar__dap--cartUser">

                                {/*
                                    Las bajas son un catalogo aparte del listado general (autos
                                    enteros, no repuestos sueltos), asi que tienen su entrada propia
                                    en la barra y no se llega por el buscador.
                                */}
                                <Nav.Link
                                    onClick={() => this.ir("/bajas")}
                                    className="navbar__dap--seccion"
                                    title="Bajas de autos"
                                >
                                    <FontAwesomeIcon icon="fa-solid fa-car-burst" size="lg"/>
                                    <span>Bajas</span>
                                </Nav.Link>

                                {/*
                                    Mensajes y notificaciones van sueltos en la barra y no adentro del
                                    menú: son lo que hay que ver sin abrir nada, porque avisan que
                                    alguien está esperando una respuesta.
                                */}
                                {autenticado && (
                                    <Nav.Link
                                        onClick={() => this.ir("/mensajes")}
                                        className="navbar__dap--cart"
                                        title="Mensajes"
                                    >
                                        <FontAwesomeIcon icon="fa-regular fa-comments" size="lg"/>
                                        {mensajesSinLeer > 0 && (
                                            <span>{mensajesSinLeer > 9 ? "9+" : mensajesSinLeer}</span>
                                        )}
                                    </Nav.Link>
                                )}

                                {autenticado && <NotificacionesBell/>}

                                {cartService.getCartSize() >= 0 && (
                                    <Nav.Link
                                        onClick={() => this.ir("/checkout")}
                                        className="navbar__dap--cart"
                                        title="Carrito"
                                    >
                                        <FontAwesomeIcon icon="fa-solid fa-cart-shopping" size="lg"/>
                                        <span>{cartService.getCartSize()}</span>
                                    </Nav.Link>
                                )}

                                <Navbar.Offcanvas
                                    id={`offcanvasNavbar-expand2-${expand}`}
                                    aria-labelledby={`offcanvasNavbarLabel-expand2-${expand}`}
                                    placement="end"
                                    className="navbar__dap--user dropdown-menu-end"
                                >
                                    <Offcanvas.Header closeButton>
                                        <Offcanvas.Title id={`offcanvasNavbarLabel-expand2-${expand}`}>
                                            {autenticado && (
                                                <span className="menuUsuario__cabecera">
                                                    <span className="menuUsuario__avatar">{iniciales}</span>
                                                    <span>
                                                        <strong>{usuario.username}</strong>
                                                        {authService.hasAuthority("VENDEDOR") && (
                                                            <small>Cuenta de vendedor</small>
                                                        )}
                                                    </span>
                                                </span>
                                            )}
                                        </Offcanvas.Title>
                                    </Offcanvas.Header>

                                    <Offcanvas.Body>
                                        <Nav className="justify-content-end flex-grow-1">

                                            {autenticado && (
                                                <>
                                                    {/* ── Mobile: el panel deslizable ── */}
                                                    <div className="navbar__dap-hidden menuUsuario">
                                                        {this.secciones().map((grupo) => (
                                                            <div className="menuUsuario__grupo" key={grupo.titulo}>
                                                                <span className="menuUsuario__titulo">
                                                                    {grupo.titulo}
                                                                </span>
                                                                {grupo.items.map((item) => (
                                                                    <Nav.Link
                                                                        key={item.ruta}
                                                                        className="menuUsuario__item"
                                                                        onClick={() => this.ir(item.ruta)}
                                                                    >
                                                                        {this.contenidoItem(item)}
                                                                    </Nav.Link>
                                                                ))}
                                                            </div>
                                                        ))}

                                                        <div className="menuUsuario__grupo menuUsuario__grupo--salir">
                                                            <Nav.Link
                                                                className="menuUsuario__item menuUsuario__item--salir"
                                                                onClick={this.cerrarSesion}
                                                            >
                                                                <FontAwesomeIcon
                                                                    icon="fa-solid fa-arrow-right-from-bracket"
                                                                    className="menuUsuario__icono"
                                                                    fixedWidth
                                                                />
                                                                <span className="menuUsuario__label">
                                                                    Cerrar sesión
                                                                </span>
                                                            </Nav.Link>
                                                        </div>
                                                    </div>

                                                    {/* ── Desktop: el dropdown ── */}
                                                    <NavDropdown
                                                        title={iniciales}
                                                        id={`offcanvasNavbarDropdown-expand2-${expand}`}
                                                        drop={"start"}
                                                        className="menuUsuario menuUsuario--dropdown"
                                                    >
                                                        <div className="menuUsuario__cabecera menuUsuario__cabecera--dropdown">
                                                            <span className="menuUsuario__avatar">{iniciales}</span>
                                                            <span>
                                                                <strong>{usuario.username}</strong>
                                                                {authService.hasAuthority("VENDEDOR") && (
                                                                    <small>Cuenta de vendedor</small>
                                                                )}
                                                            </span>
                                                        </div>

                                                        {this.secciones().map((grupo) => (
                                                            <React.Fragment key={grupo.titulo}>
                                                                <NavDropdown.Divider/>
                                                                <span className="menuUsuario__titulo">
                                                                    {grupo.titulo}
                                                                </span>
                                                                {grupo.items.map((item) => (
                                                                    <NavDropdown.Item
                                                                        key={item.ruta}
                                                                        className="menuUsuario__item"
                                                                        onClick={() => this.ir(item.ruta)}
                                                                    >
                                                                        {this.contenidoItem(item)}
                                                                    </NavDropdown.Item>
                                                                ))}
                                                            </React.Fragment>
                                                        ))}

                                                        <NavDropdown.Divider/>
                                                        <NavDropdown.Item
                                                            className="menuUsuario__item menuUsuario__item--salir"
                                                            onClick={this.cerrarSesion}
                                                        >
                                                            <FontAwesomeIcon
                                                                icon="fa-solid fa-arrow-right-from-bracket"
                                                                className="menuUsuario__icono"
                                                                fixedWidth
                                                            />
                                                            <span className="menuUsuario__label">Cerrar sesión</span>
                                                        </NavDropdown.Item>
                                                    </NavDropdown>
                                                </>
                                            )}

                                            {!autenticado && (
                                                <Nav.Link
                                                    className="button"
                                                    data-type="primary-small"
                                                    onClick={this.irAIngresar}
                                                >
                                                    Ingresar
                                                </Nav.Link>
                                            )}
                                        </Nav>
                                    </Offcanvas.Body>
                                </Navbar.Offcanvas>

                                {autenticado && (
                                    <Navbar.Toggle
                                        aria-controls={`offcanvasNavbar-expand2-${expand}`}
                                        className="navbar__dap--userInitials"
                                        title={iniciales}
                                    >
                                        {iniciales}
                                    </Navbar.Toggle>
                                )}

                                {!autenticado && (
                                    <Button
                                        className="button d-block d-sm-none"
                                        data-type="primary-small"
                                        onClick={this.irAIngresar}
                                    >
                                        Ingresar
                                    </Button>
                                )}
                            </div>
                        </div>
                    </Navbar>
                ))}
            </>
        );
    }
}

function mapState(state) {
    const {user} = state.authentication;
    const {value} = state.producto;
    return {user, value};
}

const actionCreators = {
    logout: userActions.logout,
    filtrarDesdeBusqueda: busquedaActions.filtrarDesdeBusqueda,
};

const connectedNavBar = connect(mapState, actionCreators)(NavBar);
export {connectedNavBar as NavBar};
